module.exports = __webpack_public_path__ + "static/media/998260.33ff2b5b.png";